// module_configs/appliances.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie, 
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,faUsersCog,
  faLayerGroup, faBoxes, faCog,
  faBuildingColumns,
  faMoneyBill1Wave
} from '@fortawesome/free-solid-svg-icons';

// Import Appliances components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';
import AddCustomer from '.././module_mechanics/mechanics_customer';
import CustomerList from '.././module_mechanics/mechanics_customer_list';
import AddSupplier from '.././module_mechanics/mechanics_Supplier';
import SupplierList from '.././module_mechanics/mechanics_SuppliersList';
import AddEmployee from '.././module_mechanics/mechanics_employees';
import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';
import AppliancesProducts from '.././module_appliances/appliances_products';
import AppliancesProductsList from '.././module_appliances/appliances_productslist';
import AppliancesPurchases from '.././module_appliances/appliances_Purchases';
import AppliancesPurchaseList from '.././module_appliances/appliances_PurchaseList';
import AppliancesReturn from '.././module_appliances/appliances_Return';
import AppliancesReturnList from '.././module_appliances/appliances_returnlist';
import AppliancesSell from '.././module_appliances/appliances_Sell';
import AppliancesSalesList from '.././module_appliances/appliances_SellList';
import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';
import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';
import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';
import CosmeticsTransactions from '../module_cosmetics/cosmetics_transactions';
import MechanicsAccounts from '../module_cosmetics/cosmetics_Accounts';
import MechanicsCashLedger from '../module_cosmetics/cosmetics_CashLedger';
import CosmeticsPurchaseReturn from '../module_cosmetics/cosmetics_purchasereturn';
import CosmeticsPurchaseReturnList from '../module_cosmetics/cosmetics_PurchaseReturnlist';

export const appliancesConfig = {
  moduleId: 'appliances',
  moduleName: 'Appliances',
  icon: faGaugeHigh,
  description: 'Appliances Management System',
  i18n: {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'ur', 'ps', 'ar', 'tr', 'fa', 'prs'],
    rtlLanguages: ['ur', 'ps', 'ar', 'fa', 'prs']
  },
  
  // Dashboard component
  dashboardComponent: DashboardHome,
  
  // Role configurations
  roles: {
    'admin_appliances': { level: 1, label: 'Admin', color: '#ef4444' },
    'manager_appliances': { level: 2, label: 'Manager', color: '#f59e0b' },
    'user_appliances': { level: 3, label: 'User', color: '#10b981' },
    'viewer_appliances': { level: 4, label: 'Viewer', color: '#6366f1' }
  },
  
  // Default menu groups
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'sales', name: 'Sales & Sales Returns', icon: faCartShopping, order: 2 },
    { id: 'inventory', name: 'Stock & Inventory', icon: faBoxes, order: 3 },
    { id: 'accounts', name: 'Accounts & Transactions', icon: faBuildingColumns, order: 4 },
    { id: 'billing', name: 'Billing & Renewals', icon: faFileInvoice, order: 5 },
    { id: 'settings', name: 'Settings', icon: faCog, order: 6 }
  ],
  
  // Menu configuration
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_appliances', 'manager_appliances'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_appliances', 'manager_appliances']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_appliances', 'manager_appliances']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: AppliancesProducts,
          icon: faCube,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: AppliancesProductsList,
          icon: faListAlt,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: AppliancesPurchases,
          icon: faCartPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: AppliancesPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Sales Returns',
      aliases: ['sale_return', 'sales_return', 'salereturn', 'salesreturns', 'appliances_return'],
      icon: faArrowRotateLeft,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'sales',
      position: 1,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Sales Return',
          aliases: ['add_sale_return', 'new_sale_return', 'appliances_return'],
          component: AppliancesReturn,
          icon: faRotateLeft,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'returnlist',
          label: 'Sales Return List',
          aliases: ['sale_return_list', 'sales_return_list', 'appliances_returnlist'],
          component: AppliancesReturnList,
          icon: faListCheck,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },

{
      id: 'purchasereturns',
      label: 'Purchase Returns',
      aliases: ['purchase_return', 'purchasereturn', 'purchase_returns'],
      icon: faArrowRotateLeft,
     roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addpurchasereturn',
          label: 'New Purchase Return',
          aliases: ['add_purchase_return', 'new_purchase_return', 'purchasereturn'],
          component: CosmeticsPurchaseReturn,
          icon: faRotateLeft,
         roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchasereturnlist',
          label: 'Purchase Return List',
          aliases: ['purchase_return_list', 'purchasereturnlist'],
          component: CosmeticsPurchaseReturnList,
          icon: faListCheck,
         roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },

    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 7,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: AppliancesSell,
          icon: faCartPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: AppliancesSalesList,
          icon: faClipboardList,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
     {
          id: 'financials',  // or 'accounting'
          label: 'Financials',  // or 'Accounting'
          icon: faMoneyBill1Wave,
          roles: ['admin_appliances'],
          groupId: 'accounts',
          position: 0,
          submenus: [
            {
              id: 'newtransaction',
              label: 'New Transaction',
              component: AddTransactionForm,
              icon: faPlus,
              roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'alltransactions',
              label: 'All Transactions',
              component: CosmeticsTransactions,
              icon: faMoneyBillWave,
             roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'accounts',
              label: 'Accounts',
              component: MechanicsAccounts,
              icon: faBuildingColumns, // or faUniversity
           roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'cashledger',
              label: 'Cash & Bank Ledger',
              component: MechanicsCashLedger,
              icon: faMoneyBillWave,
             roles: ['admin_appliances', 'manager_appliances']
            }
          ]
        },
    {
      id: 'billing',
      label: 'Billing & Renewals',
      aliases: ['billing', 'renewals', 'billing_renewals'],
      icon: faFileInvoice,
      roles: ['admin_appliances', 'manager_appliances'],
      groupId: 'billing',
      position: 0,
      submenus: [
        { id: 'generatebill', label: 'Generate Bill', component: null, icon: faPlus, roles: ['admin_appliances', 'manager_appliances'] },
        { id: 'billinghistory', label: 'Billing History', component: null, icon: faReceipt, roles: ['admin_appliances', 'manager_appliances'] },
        { id: 'renewals', label: 'Renewals', component: null, icon: faArrowRotateLeft, roles: ['admin_appliances', 'manager_appliances'] }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_appliances'],
      groupId: 'settings',
      position: 0,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'settings',
      position: 1,
      submenus: []
    }
  ],
  
  // Quick stats
  quickStats: [
    { id: 'todayTasks', label: "Today's Tasks", icon: 'faCheckCircle', value: 24 },
    { id: 'performance', label: 'Performance', icon: 'faChartLine', value: '85%' },
    { id: 'pendingActions', label: 'Pending Actions', icon: 'faClock', value: 12 },
    { id: 'activeUsers', label: 'Active Users', icon: 'faUsers', value: 38 }
  ],
  
  // Keyboard shortcuts
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard', menuId: 'dashboard' },
    { key: 'Alt + C', description: 'Customers', menuId: 'customers' },
    { key: 'Alt + Shift + A', description: 'Add Customer', menuId: 'customers', submenuId: 'addcustomer' },
    { key: 'Alt + Shift + B', description: 'Customer List', menuId: 'customers', submenuId: 'customerlist' },
    { key: 'Alt + S', description: 'Suppliers', menuId: 'suppliers' },
    { key: 'Alt + Shift + C', description: 'Add Supplier', menuId: 'suppliers', submenuId: 'addsupplier' },
    { key: 'Alt + Shift + D', description: 'Supplier List', menuId: 'suppliers', submenuId: 'supplierlist' },
    { key: 'Alt + E', description: 'Employees', menuId: 'employees' },
    { key: 'Alt + Shift + E', description: 'Add Employee', menuId: 'employees', submenuId: 'addemployees' },
    { key: 'Alt + Shift + F', description: 'Employees List', menuId: 'employees', submenuId: 'employeeslist' },
    { key: 'Alt + A', description: 'Sales', menuId: 'sales' },
    { key: 'Alt + Shift + G', description: 'New Sale', menuId: 'sales', submenuId: 'addsale' },
    { key: 'Alt + Shift + H', description: 'Sales List', menuId: 'sales', submenuId: 'saleslist' },
    { key: 'Alt + R', description: 'Sales Returns', menuId: 'returns' },
    { key: 'Alt + Shift + I', description: 'New Sales Return', menuId: 'returns', submenuId: 'addreturn' },
    { key: 'Alt + Shift + J', description: 'Sales Return List', menuId: 'returns', submenuId: 'returnlist' },
    { key: 'Alt + K', description: 'Stock', menuId: 'stock' },
    { key: 'Alt + Shift + K', description: 'Add Stock', menuId: 'stock', submenuId: 'addstock' },
    { key: 'Alt + Shift + L', description: 'Stock List', menuId: 'stock', submenuId: 'stocklist' },
    { key: 'Alt + U', description: 'Purchases', menuId: 'purchases' },
    { key: 'Alt + Shift + M', description: 'New Purchase', menuId: 'purchases', submenuId: 'addpurchase' },
    { key: 'Alt + Shift + N', description: 'Purchases List', menuId: 'purchases', submenuId: 'purchaselist' },
    { key: 'Alt + Shift + O', description: 'Supplier-wise Purchases', menuId: 'purchases', submenuId: 'purchasessupplierwise' },
    { key: 'Alt + Shift + P', description: 'Bill-wise Purchases', menuId: 'purchases', submenuId: 'purchasesinvoicewise' },
    { key: 'Alt + T', description: 'Purchase Returns', menuId: 'purchasereturns' },
    { key: 'Alt + Shift + Q', description: 'New Purchase Return', menuId: 'purchasereturns', submenuId: 'addpurchasereturn' },
    { key: 'Alt + Shift + R', description: 'Purchase Return List', menuId: 'purchasereturns', submenuId: 'purchasereturnlist' },
    { key: 'Alt + B', description: 'Barcodes', menuId: 'barcode' },
    { key: 'Alt + Shift + S', description: 'Barcode Printing', menuId: 'barcode', submenuId: 'barcodeprinting' },
    { key: 'Alt + F', description: 'Financials', menuId: 'financials' },
    { key: 'Alt + Shift + T', description: 'New Transaction', menuId: 'financials', submenuId: 'newtransaction' },
    { key: 'Alt + Shift + U', description: 'All Transactions', menuId: 'financials', submenuId: 'alltransactions' },
    { key: 'Alt + Shift + V', description: 'Accounts', menuId: 'financials', submenuId: 'accounts' },
    { key: 'Alt + Shift + W', description: 'Cash & Bank Ledger', menuId: 'financials', submenuId: 'cashledger' },
    { key: 'Alt + L', description: 'Billing & Renewals', menuId: 'billing' },
    { key: 'Alt + Shift + X', description: 'Generate Bill', menuId: 'billing', submenuId: 'generatebill' },
    { key: 'Alt + Shift + Y', description: 'Billing History', menuId: 'billing', submenuId: 'billinghistory' },
    { key: 'Alt + Shift + Z', description: 'Renewals', menuId: 'billing', submenuId: 'renewals' },
    { key: 'Alt + O', description: 'Settings', menuId: 'settings' },
    { key: 'Alt + V', description: 'Notifications Center', menuId: 'systemupdates' },
    { key: 'Escape', description: 'Hide or show sidebar', action: 'toggleSidebar' },
    { key: 'Alt + J', description: 'Open or close shop switcher', action: 'toggleShopSwitcher' },
    { key: 'Alt + M', description: 'Change to next theme color', action: 'cycleTheme' },
    { key: 'Alt + X', description: 'Switch dark or light mode', action: 'toggleDarkMode' },
    { key: 'Alt + Q', description: 'Focus menu search', action: 'focusSearch' },
    { key: 'Alt + Y', description: 'Change to next language', action: 'cycleLanguage' },
    { key: 'Alt + H', description: 'Show or hide keyboard shortcuts', action: 'toggleShortcuts' }
  ]
};
